export { default } from "./kitDetailsSection";
